export default "__VITE_ASSET__PYDwQLwa__"